(() => {
  const TABLES = Object.freeze({
    hispano: Object.freeze([
      { cm: 22, eu: '36', usM: '4', usW: '5.5', uk: '3' },
      { cm: 23, eu: '37', usM: '5', usW: '6.5', uk: '4' },
      { cm: 23.5, eu: '38', usM: '5.5', usW: '7', uk: '4.5' },
      { cm: 24, eu: '38.5', usM: '6', usW: '7.5', uk: '5' },
      { cm: 24.5, eu: '39', usM: '6.5', usW: '8', uk: '5.5' },
      { cm: 25, eu: '40', usM: '7', usW: '8.5', uk: '6' },
      { cm: 25.5, eu: '40.5', usM: '7.5', usW: '9', uk: '6.5' },
      { cm: 26, eu: '41', usM: '8', usW: '9.5', uk: '7' },
      { cm: 26.5, eu: '42', usM: '8.5', usW: '10', uk: '7.5' },
      { cm: 27, eu: '42.5', usM: '9', usW: '10.5', uk: '8' },
      { cm: 27.5, eu: '43', usM: '9.5', usW: '11', uk: '8.5' },
      { cm: 28, eu: '44', usM: '10', usW: '11.5', uk: '9' },
      { cm: 28.5, eu: '44.5', usM: '10.5', usW: '12', uk: '9.5' },
      { cm: 29, eu: '45', usM: '11', usW: '12.5', uk: '10' },
      { cm: 30, eu: '46', usM: '12', usW: '13.5', uk: '11' },
      { cm: 30.5, eu: '47', usM: '12.5', usW: '14', uk: '11.5' },
      { cm: 31.5, eu: '48', usM: '13.5', usW: '15', uk: '12.5' },
    ]),
    levito: Object.freeze([
      { cm: 22, eu: '36', usM: '4', usW: '5.5', uk: '3' },
      { cm: 23, eu: '37', usM: '5', usW: '6.5', uk: '4' },
      { cm: 24, eu: '38', usM: '6', usW: '7.5', uk: '5' },
      { cm: 25, eu: '39', usM: '7', usW: '8.5', uk: '6' },
      { cm: 26, eu: '40', usM: '8', usW: '9.5', uk: '7' },
      { cm: 27, eu: '41', usM: '9', usW: '10.5', uk: '8' },
      { cm: 28, eu: '42', usM: '10', usW: '11.5', uk: '9' },
      { cm: 29, eu: '43', usM: '11', usW: '12.5', uk: '10' },
      { cm: 30, eu: '44', usM: '12', usW: '13.5', uk: '11' },
      { cm: 31, eu: '45', usM: '13', usW: '14.5', uk: '12' },
      { cm: 32, eu: '46', usM: '14', usW: '15.5', uk: '13' },
    ]),
  });

  const createElement = (tag, className, text) => {
    const element = document.createElement(tag);
    element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };

  class BBSizeCalculator extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.input = this.querySelector('.bb-size-calculator__input');
      this.button = this.querySelector('.bb-size-calculator__button');
      this.error = this.querySelector('.bb-size-calculator__error');
      this.result = this.querySelector('.bb-size-calculator__result');
      this.table = TABLES[this.dataset.model] || TABLES.hispano;

      const d = this.dataset;
      this.locale = d.locale || 'es';
      this.t = {
        invalid: d.tInvalid || 'Introduce una medida válida en cm.',
        nosize: d.tNosize || 'No tenemos una talla para {cm} cm. Escríbenos y te ayudamos.',
        fail: d.tFail || 'No hemos podido calcular la talla. Escríbenos y te ayudamos.',
        result: d.tResult || 'Tu talla recomendada',
        between: d.tBetween || 'Estás entre dos medidas: te recomendamos la talla superior.',
      };

      if (!this.input || !this.button || !this.error || !this.result) return;

      this.button.addEventListener('click', () => this.calculate());
      this.input.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        this.calculate();
      });
    }

    calculate() {
      const normalizedValue = this.input.value.trim().replace(',', '.');
      const measurement = Number(normalizedValue);

      this.hideFeedback();

      if (normalizedValue === '' || !Number.isFinite(measurement)) {
        this.showError(this.t.invalid);
        return;
      }

      const minimum = this.table[0].cm;
      const maximum = this.table[this.table.length - 1].cm;

      if (measurement < minimum || measurement > maximum) {
        let shown = String(measurement);
        try {
          shown = measurement.toLocaleString(this.locale);
        } catch (error) {}
        this.showError(this.t.nosize.replace('{cm}', shown));
        return;
      }

      const exact = this.table.find((size) => Math.abs(size.cm - measurement) < 0.001);
      const recommendation = exact || this.table.find((size) => size.cm > measurement);

      if (!recommendation) {
        this.showError(this.t.fail);
        return;
      }

      this.showResult(recommendation, !exact);
    }

    hideFeedback() {
      this.error.hidden = true;
      this.error.textContent = '';
      this.result.hidden = true;
      this.result.replaceChildren();
    }

    showError(message) {
      this.error.textContent = message;
      this.error.hidden = false;
    }

    showResult(size, roundedUp) {
      const card = createElement('div', 'bb-size-calculator__result-card');
      card.append(createElement('div', 'bb-size-calculator__result-label', this.t.result));

      const grid = createElement('div', 'bb-size-calculator__grid');
      [
        ['EU', size.eu],
        ['US M', size.usM],
        ['US W', size.usW],
        ['UK', size.uk],
      ].forEach(([system, value]) => {
        const cell = createElement('div', 'bb-size-calculator__cell');
        cell.append(
          createElement('div', 'bb-size-calculator__system', system),
          createElement('div', 'bb-size-calculator__value', value)
        );
        grid.append(cell);
      });
      card.append(grid);

      if (roundedUp) {
        card.append(createElement('p', 'bb-size-calculator__note', this.t.between));
      }

      this.result.append(card);
      this.result.hidden = false;
    }
  }

  if (!customElements.get('bb-size-calculator')) {
    customElements.define('bb-size-calculator', BBSizeCalculator);
  }
})();
